
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";

interface ContactFormBusinessTypeProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const ContactFormBusinessType = ({ value, onChange }: ContactFormBusinessTypeProps) => {
  const { t } = useLanguage();
  
  return (
    <div>
      <label htmlFor="businessType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('contact_business_type')}
      </label>
      <select
        id="businessType"
        name="businessType"
        value={value}
        onChange={onChange}
        className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50"
      >
        <option value="">{t('business_type_default')}</option>
        <option value="small">{t('business_type_small')}</option>
        <option value="medium">{t('business_type_medium')}</option>
        <option value="large">{t('business_type_large')}</option>
        <option value="sole">{t('business_type_sole')}</option>
      </select>
    </div>
  );
};

export default ContactFormBusinessType;
